export default __webpack_public_path__ + "locales/zh-CN/Common.json?hash=91a733b9885b97ff2d93644df53c6c56";